import { useEffect, useState } from 'react';
import { fetchFlights, formatUpdatedLabel } from '../utils/flightsApi.js';

/**
 * Load live arrivals + departures for the homepage board.
 * @param {{ limit?: number }} [opts]
 */
export function useHomeFlights(opts = {}) {
  const limit = opts.limit ?? 6;
  const [arrivals, setArrivals] = useState([]);
  const [departures, setDepartures] = useState([]);
  const [updatedLabel, setUpdatedLabel] = useState('—');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const [arr, dep] = await Promise.all([
          fetchFlights('arrivals'),
          fetchFlights('departures'),
        ]);
        if (cancelled) return;
        const arrivalsSlice = arr.slice(0, limit);
        const departuresSlice = dep.slice(0, limit);
        setArrivals(arrivalsSlice);
        setDepartures(departuresSlice);
        setUpdatedLabel(formatUpdatedLabel([...arrivalsSlice, ...departuresSlice]));
      } catch (err) {
        if (cancelled) return;
        setArrivals([]);
        setDepartures([]);
        setError(err?.message || 'Unable to load flights');
        setUpdatedLabel(formatUpdatedLabel([]));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [limit]);

  return { arrivals, departures, updatedLabel, loading, error };
}
